import { get, post, lget } from '../index'
// import { IBannerQuery } from '~/typings/index'

interface CountryListApiParams {
  type: number | string
  countryQueryType?: number | string
}

// 获取business type/role
export async function getBusinessTypeList () {
  return await get('/user/getTypeList')
}

// 获取region/country list
export async function getCountryList (params: CountryListApiParams) {
  const { type, countryQueryType } = params
  const data: CountryListApiParams = { type }
  if (countryQueryType !== undefined && countryQueryType !== null) {
    data.countryQueryType = countryQueryType
  }
  return await get('/certification/regionInfo/getList', data)
}

// 获取province/state | city list
export async function getProvinceCityConfig () {
  return await get('/certification/provinceCity/getListForSupplement')
}

// 获取首页补充信息配置form item object项
export async function getSupplementInfo (data?: { regionId: number }) {
  return await get('/certification/supplementInfo/query', data)
}

// 首页-获取banner信息
export async function getBannerInfo (data: { typeList: string[] }) {
  return await post('/certification/banner/release/query', data)
}

// 首页-获取用户评论信息
export async function getAboutUsInfo () {
  return await post('/certification/aboutUs/query')
}

// 首页-获取教师团队信息
export async function getTrainerInfoList () {
  return await post('/certification/trainerTeam/query')
}

// 首页-获取数据库配置的图片
export async function getHomeImages (type = 'page_image') {
  return await get('/certification/dictData/getDictModelList', { dictType: type })
}

// 全局-获取siteId
export async function getSiteInfo (data: { siteName: string }) {
  return await lget('/front-api/getSiteInfo', data)
}

// 全局-获取i18n信息
export async function getMultiLang (data?: { languagePackId: number }) {
  return await get('/certification/language/multi', data)
}

// 全局-获取用户信息
export async function getUserInfo () {
  return await get('/user/sso/getUserInfo')
}

// 全局-获取页脚信息
export async function getFooterConfig () {
  return await get('/certification/footer/findAll')
}

// 全局-获取页脚信息
export async function getSiteLanguageConfig () {
  return await post('/certification/languageSwitch/listByParam')
}

// 根据ip获取国家信息，可以不传ip参数，后端会根据用户访问ip获取对应code
export async function getCountryByIp (data?: { ip: string }) {
  return await get('/certification/location/getCountryByIp', data)
}

// 获取Faq页面的信息
export async function getFAQConfigList () {
  return await post('/certification/faq/release/query')
}

// 向数据库批量导入i18n数据，需要自己手动调
export async function batchImportLanguage (data: Array<{ textCode: string, textName: string, siteId: string }>) {
  return await post('/certification/language/add', data)
}

// 获取配置的seo信息
export async function getSeoConfigBySite () {
  return await post('/certification/seo/getRelBySiteId')
}

export async function getTopNewsList () {
  return await get('/certification/news/released/getTopNewsList')
}

export async function loginBySign (data: { oneHikIdSign?: string, appId?: string }) {
  return await post('/user/sso/oneHikIdSign/verify', data)
}

export async function getAuthLink (data: { releaseCertificationId: string | number}) {
  const { releaseCertificationId } = data
  return await post(`/user/certificationApply/getCertificateAuthLink?releaseCertificationId=${releaseCertificationId}`, data)
}

// 获取认证类型
export async function getCertificationKindList () {
  return await get('/certification/getKindList')
}

// 获取站点反馈
export async function getSiteFeedback () {
  return await get('/certification/siteFeedback/getBySiteId')
}

// 获取国家语言列表
export async function getCountryLangList () {
  return await post('/certification/countryLanguage/getList')
}

// 获取站点基本信息
export async function getSiteInfoByIds (data: { id: number | string }) {
  return await post('/certification/site/getListByIds', data)
}

// 批量获取字典表的数据
export async function getDictModelList (data: {
  dictTypeList: string[]
}) {
  return await post('/certification/dictData/batchQueryDictModelList', data)
}

// 批量获取字典表的数据
export async function getUserComplateProject () {
  return await post('/user/registration/listUserIncompleteProject')
}

export async function getRecommendedCourse (data?: { languageId: number | string }) {
  return await post('/certification/recommendation/getHomePageCourseList', data)
}

export async function getRecommendedClass (data?: { languageId: number | string }) {
  return await post('/certification/recommendation/getHomePageClassroom', data)
}

// 获取站点下所有的国家id
export async function getRegionListBySiteId () {
  return await post('/certification/regionInfo/listRegionIdByParam')
}
// 获取站点下所有认证的语言
export async function getLanguageBySiteId () {
  return await get('/certification/getCertificationLanguageBySiteId')
}
// 获取站点下所有有实操的认证
export async function getCertificationWithPracticalExam (data: { kind: string }) {
  return await get('/certification/getCertificationOfPracticalExam', data)
}
